module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24626/sass/messagesWidgetShell.sass"